import { configureStore, Middleware } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { isNumber } from 'lodash';
import { combineReducers } from 'redux';

import { api } from '../services/api';

import carDetail from './carDetail';
import common from './common';
import inspection from './inspection';
import toastReducer, { clearToast, setErrorToast } from './toast';

const reducers = combineReducers({
  api: api.reducer,
  inspection,
  carDetail,
  common,
  toast: toastReducer,
});

const statusError: number[] = [400, 401, 403, 404, 405, 422, 429]; // Example toast statuses

interface IError {
  title: string;
  detail: string;
}

const errorMiddleware: Middleware = () => (next) => (action) => {
  if (typeof action === 'object' && action.payload) {
    const isError = isNumber(action.payload.status) && statusError.includes(action.payload.status);

    if (isError) {
      action.payload.data.map((errorItem: IError) => {
        store.dispatch(
          setErrorToast({
            message: errorItem.detail,
            title: errorItem.title,
          }),
        );
      });

      setTimeout(() => {
        store.dispatch(clearToast());
      }, 0);
    }
    return next(action);
  }
  return next(action);
};

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware: any) => {
    return getDefaultMiddleware({}).concat(api.middleware).concat(errorMiddleware);
  },
});

setupListeners(store.dispatch);
export { store };
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
